import React from "react"
import clsx from "clsx"
import RadioSelect from "../../Selects/RadioSelect"

class PropertyDetailsBuilderAccount extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var roomTypesClasses = clsx({
      'active': this.props.active_tab == 'account',
      'tab-pane': true
    })
    var inputs = this.props.all_accounts.map(account => {
      return {
        label_primary: account.name,
        id: account.id
      }
    })
    return (
      <div className={roomTypesClasses} id="account">
        <div className="row">
          <div className="col-md-12">
            <RadioSelect
              onChange={this.props.onChangeAccountId}
              inputs={inputs}
              selected_input={this.props.account_id}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default PropertyDetailsBuilderAccount